import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { Search } from 'b2b-apps/shop/catalog/api/Search';
import {
  fetchInkManufacturersFulfilled,
  fetchInkManufacturersRejected,
  fetchInkModelsFulfilled,
  fetchInkModelsRejected,
} from 'b2b-apps/shop/catalog/redux/inkFinder/actionCreators';
import {
  FETCH_INK_MANUFACTURERS,
  FETCH_INK_MODELS,
  TOGGLE_INK_WIDGET,
} from 'b2b-apps/shop/catalog/redux/inkFinder/actionTypes';
import {
  FetchInkManufacturersAction,
  FetchInkModelsAction,
  ToggleInkWidgetAction,
} from 'b2b-apps/shop/catalog/redux/inkFinder/types';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { setCookie } from 'b2b-apps/shop/common/utils/storage/cookies';
import { getActiveLanguage } from 'b2b-apps/shop/i18n/redux/selectors';

const INK_FINDER_WIDGET_COOKIE_KEY = 'isInkWidgetOpen';

enum FETCH_MANUFACTURERS_QUERY {
  de = 'path=/computing-software/peripherie/tinte-toner&searchEarlyFilter=true&format=json',
  fr = 'path=/fr/computing-logiciels/peripheriques/encre-toner&searchEarlyFilter=true&format=json',
}

function* fetchInkManufacturersSaga(
  action: FetchInkManufacturersAction,
): Generator<any, any, any> {
  const language = yield select(getActiveLanguage);
  const fetchManufacturersQuery = FETCH_MANUFACTURERS_QUERY[language];

  try {
    const response = yield call(requestApiSaga, Search.fetch(fetchManufacturersQuery));
    yield put(
      fetchInkManufacturersFulfilled(
        Search.mapResponseToInkManufacturersState(response),
      ),
    );
  } catch (error) {
    yield put(fetchInkManufacturersRejected(parseError(error)));
    yield put(reportError(action.type, error));
  }
}

function* fetchInkModelsSaga(
  action: FetchInkModelsAction,
): Generator<any, any, any> {
  const { query } = action.payload;

  try {
    const response = yield call(requestApiSaga, Search.fetch(query));
    yield put(
      fetchInkModelsFulfilled(
        Search.mapResponseToInkModelsState(response),
      ),
    );
  } catch (error) {
    yield put(fetchInkModelsRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* toggleInkWidgetSaga(
  action: ToggleInkWidgetAction,
): Generator<any, any, any> {
  const { isOpen } = action.payload;
  yield setCookie(INK_FINDER_WIDGET_COOKIE_KEY, +!!isOpen);
}

function* inkFinderSaga(): Generator<any, any, any> {
  yield all([
    takeLatest(FETCH_INK_MANUFACTURERS, fetchInkManufacturersSaga),
    takeLatest(FETCH_INK_MODELS, fetchInkModelsSaga),
    takeLatest(TOGGLE_INK_WIDGET, toggleInkWidgetSaga),
  ]);
}

export {
  INK_FINDER_WIDGET_COOKIE_KEY,
  inkFinderSaga,
};
